var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72284 7.38965L5.70076 4.45587H6.96567L7.94359 7.38965L10.8774 8.36757V9.63248L7.94359 10.6104L6.96567 13.5442H5.70076L4.72284 10.6104L1.78906 9.63248V8.36757L4.72284 7.38965ZM6.33321 6.77488L5.88234 8.12751L5.4607 8.54915L4.10807 9.00003L5.4607 9.4509L5.88234 9.87254L6.33321 11.2252L6.78409 9.87254L7.20573 9.4509L8.55836 9.00003L7.20573 8.54915L6.78409 8.12751L6.33321 6.77488Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.767 3.4338L11.2871 1.87354H12.046L12.5661 3.4338L14.1264 3.95389V4.71283L12.5661 5.23292L12.046 6.79318H11.2871L10.767 5.23292L9.20672 4.71283V3.95389L10.767 3.4338Z",
    fill: "#5F6368",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/tn.59e3763f608f977970fa3a0b894d4189.svg";
export { ForwardRef as ReactComponent };